import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { Row } from "react-bootstrap";
import SectionHeader from "components/SectionHeader";
import CampaignsItem from "components/CampaignsItem";
import PageSection from "components/PageSection";
import "./Campaigns.scss";

const Campaigns = ({ className, frontmatter }) => {
  if (!frontmatter) {
    return null;
  }

  const { anchor, header: rootHeader, subheader: rootSubHeader, campaigns } = frontmatter;

  return (
    <PageSection className={clsx("campaigns-section", className)} id={anchor}>
      <Row>
        <SectionHeader header={rootHeader} subheader={rootSubHeader} />
      </Row>
      <Row>
        {campaigns.map(
          ({ content, extraInfo, header, imageFileName, imageFileNameDetail, subheader }) => (
            <CampaignsItem
              key={header}
              imageFileName={imageFileName}
              header={header}
              subheader={subheader}
              content={content}
              imageFileNameDetail={imageFileNameDetail}
              extraInfo={
                <ul>
                  {extraInfo.map((ei) => (
                    <li key={ei}>{ei}</li>
                  ))}
                </ul>
              }
            />
          ),
        )}
      </Row>
    </PageSection>
  );
};

Campaigns.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

Campaigns.defaultProps = {
  className: null,
  frontmatter: null,
};

export default Campaigns;
